// extracted by mini-css-extract-plugin
module.exports = {"Snackbar":"Snackbar__2nucU","Message":"Message__3pI6q"};